<template>
  <v-container id="transaction-table">
    <MaterialCard
      elevation="0"
      color="primary"
      :title="this.$t('title.transactions')"
      class="tour-start"
    >
      <base-datatable
        :header_items="headers"
        :type="this.$t('title.transactions')"
        dispatch_get="transactions/transactions"
        view_route="transactionview"
        :custom_sort="customSort"
      >
      </base-datatable>
    </MaterialCard>
  </v-container>
</template>

<script>
import MaterialCard from "../../../../../components/views/MaterialCard";
import { transaction_table } from "@/mixins/transaction";
import BaseDatatable from "../../../../../components/views/BaseDatatable";

export default {
  name: "Transactions",
  components: { BaseDatatable, MaterialCard },
  mixins: [transaction_table],
  methods: {
    customSort(items) {
      return items;
    }
  }
};
</script>
